import React, { useEffect, useState } from 'react';
import {
  getProductModeInfo,
  licenseStateLabel,
  productModeLabel,
  saveLicenseEntitlements,
  saveLicenseTimeStatus,
} from '../../lib/productMode';
import { createDeviceLicenseRequest, validateLicenseDeviceLock } from '../../lib/deviceLicense';
import { validateLicenseTimeWindow } from '../../lib/licenseFile';
import { getTrustedTime } from '../../lib/trustedTime';
import { isDesktopRuntime } from '../../lib/rustCalculationEngine';

export const LICENSE_STATUS_CHANGED_EVENT = 'revenue:license-status-changed';

export function LicenseStatusBanner() {
  const [info, setInfo] = useState(() => getProductModeInfo());

  useEffect(() => {
    const refresh = () => setInfo(getProductModeInfo());
    window.addEventListener(LICENSE_STATUS_CHANGED_EVENT, refresh);
    window.addEventListener('storage', refresh);
    const verifyLicenseTime = async () => {
      const current = getProductModeInfo();
      if (!current.entitlements) return;
      if (!isDesktopRuntime()) return;
      try {
        const deviceRequest = await createDeviceLicenseRequest();
        validateLicenseDeviceLock(current.entitlements, deviceRequest.deviceLockHash);
        const trustedTime = await getTrustedTime();
        validateLicenseTimeWindow(current.entitlements, trustedTime);
        saveLicenseEntitlements({
          ...current.entitlements,
          trustedTimeUnixSeconds: trustedTime.unixSeconds,
          trustedTimeServer: trustedTime.server,
        });
        saveLicenseTimeStatus({
          state: 'valid',
          trustedTimeUnixSeconds: trustedTime.unixSeconds,
          trustedTimeServer: trustedTime.server,
        });
      } catch (error) {
        const isDeviceMismatch = error instanceof Error && error.message.includes('別のPC');
        saveLicenseTimeStatus({
          state: isDeviceMismatch
            ? 'device-mismatch'
            : error instanceof Error && error.message.includes('NTP')
            ? 'unavailable'
            : 'invalid',
          reason: error instanceof Error ? error.message : 'ライセンス時刻検証に失敗しました',
        });
      } finally {
        refresh();
        window.dispatchEvent(new Event(LICENSE_STATUS_CHANGED_EVENT));
      }
    };
    void verifyLicenseTime();
    return () => {
      window.removeEventListener(LICENSE_STATUS_CHANGED_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  const isDemo = info.mode === 'demo';
  if (info.licenseState === 'licensed') return null;

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 lg:px-6">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-semibold">{productModeLabel(info.mode)}モード</span>
        <span>{licenseStateLabel(info.licenseState)}</span>
        {isDemo ? (
          <span className="text-amber-800">
            サンプルの数字は変更できますが、プロジェクト名と相手先は固定されます。出力には未ライセンス透かしが入ります。
          </span>
        ) : info.entitlements ? (
          <span className="text-amber-800">{info.entitlements.licensedUserName}</span>
        ) : null}
      </div>
    </div>
  );
}
